import { createSlice } from "@reduxjs/toolkit";

import { setDeep } from "Libs/objectAccess";

import { getOrganizationAddress, updateOrganizationAddress } from "./thunks";

import type { OrganizationAddressState } from "./types";

const initialState: OrganizationAddressState = { data: {} };

const organizationAddressReducer = createSlice({
  name: "app/organization/address",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      // GET ADDRESS
      .addCase(getOrganizationAddress.pending, (state, { meta }) => {
        const { organizationId } = meta.arg;

        setDeep(state, ["data", organizationId, "loadingGet"], true);
        setDeep(state, ["data", organizationId, "error"], undefined);
      })
      .addCase(getOrganizationAddress.fulfilled, (state, { meta, payload }) => {
        const { organizationId } = meta.arg;
        setDeep(state, ["data", organizationId, "address"], payload);
        setDeep(state, ["data", organizationId, "loadingGet"], false);
      })
      .addCase(getOrganizationAddress.rejected, (state, { meta, payload }) => {
        const { organizationId } = meta.arg;

        setDeep(state, ["data", organizationId, "loadingGet"], false);
        setDeep(state, ["data", organizationId, "error"], payload);
      }) // UPDATE ADDRESS
      .addCase(updateOrganizationAddress.pending, (state, { meta }) => {
        const { organizationId } = meta.arg;

        setDeep(state, ["data", organizationId, "loadingUpdate"], true);
        setDeep(state, ["data", organizationId, "error"], undefined);
      })
      .addCase(
        updateOrganizationAddress.fulfilled,
        (state, { meta, payload }) => {
          const { organizationId } = meta.arg;
          setDeep(state, ["data", organizationId, "address"], payload);
          setDeep(state, ["data", organizationId, "loadingUpdate"], false);
        }
      )
      .addCase(
        updateOrganizationAddress.rejected,
        (state, { meta, payload }) => {
          const { organizationId } = meta.arg;

          setDeep(state, ["data", organizationId, "loadingUpdate"], false);
          setDeep(state, ["data", organizationId, "error"], payload);
        }
      );
  }
});

export default organizationAddressReducer.reducer;
